import { marker } from '@jsverse/transloco-keys-manager/marker';

/** FAQ keys for Ministry Money onboarding in money-in-settings — content under `trip-finances.money-in-settings.faq.items.<id>`. */
export const MONEY_IN_SETTINGS_FAQ_ITEM_IDS = [
  'what-is-ministry-money',
  'how-much-ministry-money',
] as const;

export type MoneyInSettingsFaqItemId = (typeof MONEY_IN_SETTINGS_FAQ_ITEM_IDS)[number];

/** See `faq-item-ids.ts` — dynamic Transloco prefix needs marker extraction. */
void [
  marker('trip-finances.money-in-settings.faq.items.what-is-ministry-money.question'),
  marker('trip-finances.money-in-settings.faq.items.what-is-ministry-money.paragraphs'),
  marker('trip-finances.money-in-settings.faq.items.how-much-ministry-money.question'),
  marker('trip-finances.money-in-settings.faq.items.how-much-ministry-money.paragraphs'),
];
